import { useStoreId } from "$/hooks/use-store-information"
import { userQueryOptions } from "$/lib/queries/user-queries"
import { WorkerRole } from "@repo/common"
import { useSuspenseQuery } from "@tanstack/react-query"

type UserRole = {
  isWorker: boolean
  isOwner: boolean
  isAdmin: boolean
}

export function useUserRole(): UserRole {
  const storeId = useStoreId()
  const { data: user } = useSuspenseQuery(userQueryOptions)

  const isAdmin = user?.isAdmin || false

  const isOwner =
    isAdmin ||
    user?.roles.some(
      (role) => role.storeId === storeId && role.role === WorkerRole.OWNER,
    ) ||
    false

  const isWorker =
    isOwner ||
    user?.roles.some(
      (role) => role.storeId === storeId && role.role === WorkerRole.EMPLOYEE,
    ) ||
    false

  return { isWorker, isOwner, isAdmin }
}
